import React, { useEffect, useState } from "react";
import { ArrowUpRight, TrendingUp } from "lucide-react";
import { fetchCaseStudies } from "../lib/api";

export default function CaseStudies() {
  const [cases, setCases] = useState([]);

  useEffect(() => {
    fetchCaseStudies().then(setCases).catch(() => setCases([]));
  }, []);

  return (
    <section id="cases" className="nst-light py-24 lg:py-32">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div>
            <span className="pill-label">Case Studies</span>
            <h2 className="mt-6 text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#0A1F47] leading-[1.05]">
              What We’ve <span className="text-[#2E6BF6]">Delivered</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {cases.map((c) => (
            <article
              key={c.slug}
              className="group relative overflow-hidden rounded-3xl bg-[#0A1F47] text-white p-10 border border-[#0A1F47] card-lift hover:shadow-[0_25px_60px_-20px_rgba(10,31,71,0.4)]"
            >
              <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-[#2E6BF6]/30 blur-3xl pointer-events-none" />
              <div className="relative">
                <div className="flex items-center justify-between mb-8">
                  <span className="pill-label on-dark">
                    <TrendingUp className="w-3.5 h-3.5" />
                    {c.tag}
                  </span>
                  <span className="w-11 h-11 rounded-full border border-white/20 flex items-center justify-center group-hover:bg-[#2E6BF6] group-hover:border-[#2E6BF6] transition-colors">
                    <ArrowUpRight className="w-5 h-5" />
                  </span>
                </div>
                <h3 className="text-3xl md:text-4xl font-extrabold leading-tight">{c.title}</h3>
                <p className="mt-4 text-white/70 leading-relaxed max-w-lg">{c.description}</p>
                <div className="mt-8 grid grid-cols-3 gap-4 border-t border-white/10 pt-6">
                  {c.metrics.map((m) => (
                    <div key={m.k}>
                      <div className="text-[11px] uppercase tracking-wider text-white/50 font-semibold">{m.k}</div>
                      <div className="text-sm font-bold text-white mt-1">{m.v}</div>
                    </div>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
